import { render, staticRenderFns } from "./Imgfundo.vue?vue&type=template&id=3d3c9f5a"
import script from "./Imgfundo.vue?vue&type=script&lang=js"
export * from "./Imgfundo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports